import { render, staticRenderFns } from "./TermDetailsTab.vue?vue&type=template&id=220b371a&scoped=true&"
import script from "./TermDetailsTab.vue?vue&type=script&lang=js&"
export * from "./TermDetailsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220b371a",
  null
  
)

export default component.exports